// Who else went for a team a manager won on waivers, sorted into the two
// different ways a claim loses, for the league activity feed.
//
// resolve_waivers works through claims in rank tiers: every manager's first
// choice across the league, then every second choice, and so on. So a claim
// marked lost lost in one of two ways, and only one of them is about money:
//
//   - Same tier as the winner: the two were compared, and the winner's bid
//     was higher (or equal, and the standings tiebreak went their way). That
//     manager was outbid.
//   - A later tier: by the time it came up the team was already gone. Its
//     amount was never compared with anything, and can be far higher than the
//     winning bid. A manager who bids $70 on five teams and gets their first
//     choice loses the other four this way.
//
// The feed used to list both as "Outbid", which is how a $5 win came to read
// as having outbid $70.

const RIVALS_SHOWN = 2;

// A bid from before claims were ranked has no rank, and every claim then was
// its manager's only one for that team: first choice.
const rankOf = (bid) => bid.claim_rank ?? 1;

/**
 * @param {{ amount: number, claim_rank?: number }} wonBid
 * @param {{ member_id: string, amount: number, claim_rank?: number }[]} lostBids
 *   the lost bids on the same team in the same run
 * @returns {{ outbid: { memberId, amount }[], laterChoice: { memberId, amount, rank }[] }}
 *   at most two of each, highest bid first
 */
export function splitWaiverRivals(wonBid, lostBids) {
  const byAmount = [...(lostBids || [])].sort((a, b) => b.amount - a.amount);
  const sameTier = byAmount.filter((b) => rankOf(b) <= rankOf(wonBid));
  const later = byAmount.filter((b) => rankOf(b) > rankOf(wonBid));

  return {
    outbid: sameTier.slice(0, RIVALS_SHOWN).map((b) => ({ memberId: b.member_id, amount: b.amount })),
    laterChoice: later.slice(0, RIVALS_SHOWN).map((b) => ({ memberId: b.member_id, amount: b.amount, rank: rankOf(b) })),
  };
}
